<script setup lang="ts">
defineProps<{
  src: string;
}>();
</script>

<template>
  <img class="context-menu-icon" :src="src" alt="" draggable="false" />
</template>
